import { mapState } from 'vuex';
import {CONNECTION_ERROR_MESSAGE, CONNECTION_ERROR_TEXT} from "@/helper/httpService";
import staticPagesDummyData from '@/store/dummyData/staticPages';

/**
 * Generates mixin for given content Paths. Each path is expected to be in the staticPagesContent module in the store.
 * The mixin provides:
 * - for each path a computed property of the same name, mapping to the property in the staticPagesContent module
 * - computed property isInitialized to check if data for all paths is available
 * - start loading data for all paths in created hook
  */
export default function contentLoadingMixin(contentPaths) {
  return {
    data () {
      return {
        loadingError: false,
        loadingErrorMessage: CONNECTION_ERROR_MESSAGE,
        loadingErrorHint: CONNECTION_ERROR_TEXT
      };
    },
    computed: {
      ...mapState(contentPaths.reduce((previousContent, path) => {
        previousContent[path] = state => state.staticPagesContent[path];
        return previousContent;
      }, {})),
      isInitialized () {
        return contentPaths.every(path => this[path] !== null);
      }
    },
    created() {
      if (!this.isInitialized) {
        this.loadingError = false;
        this.$store.dispatch("populateContent", contentPaths)
          .catch(() => {
            if (this.$store.state.env.environment === 'development') {
              contentPaths.forEach(p => this.$store.commit("updateStaticContent", {
                path: p,
                newContent: staticPagesDummyData[p],
                isCharta: this.$store.getters.isChartaUser,
                isPool: this.$store.getters.isPoolUser
              }));
            } else {
              this.loadingError = true;
            }
          });
      }
    },
  };
}
